module.exports = __webpack_public_path__ + "img/IT0000732456981.4be8f51d.png";